import { render, staticRenderFns } from "./ServiceQuickness.vue?vue&type=template&id=2c95d661&scoped=true"
import script from "./ServiceQuickness.vue?vue&type=script&lang=js"
export * from "./ServiceQuickness.vue?vue&type=script&lang=js"
import style0 from "./ServiceQuickness.vue?vue&type=style&index=0&id=2c95d661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95d661",
  null
  
)

export default component.exports